import { DateTime } from 'luxon'

export const convertTimeZoneToGmtOffset = (timeZone: TimeZone | undefined): string => {
  if (!timeZone) {
    return ''
  }

  // Using korean locale because it's the only one giving GMT values for all zones
  const date = new Intl.DateTimeFormat('ko-KR', { timeZone: timeZone.zone, timeZoneName: 'short' }).format(new Date())

  const offset = date.split('GMT').pop()
  const offsetArray = offset?.split('')
  const sign = offsetArray?.shift()

  switch (offsetArray?.length) {
    case 5: // example: 12:45
      return `(GMT${sign}${offsetArray.join('')})`
    case 4: // example: 9:30
      return `(GMT${sign}0${offsetArray.join('')})`
    case 2: // example: 12
      return `(GMT${sign}${offsetArray.join('')}:00)`
    case 1: // example: 2
      return `(GMT${sign}0${offsetArray.join('')}:00)`
    default:
      return '(GMT)'
  }
}

export const getTimeZoneById = (timeZones: TimeZone[] = [], timeZoneId?: number | string): TimeZone | undefined => {
  if (timeZoneId === undefined || timeZoneId === null || timeZoneId === '') {
    return undefined
  }

  return timeZones.find((timeZone) => Number(timeZone.id) === Number(timeZoneId))
}

export const convertUtcDateTimeToTimeZone = (
  utcDateTime: string | undefined,
  timeZone: string | TimeZone | undefined,
): string => {
  if (!utcDateTime) {
    return ''
  }

  const zone = typeof timeZone === 'string' ? timeZone : timeZone?.zone
  if (!zone) {
    return utcDateTime.replace('Z', '')
  }

  const dt = DateTime.fromISO(utcDateTime, { zone: 'utc' }).setZone(zone)
  return dt.toISO({ suppressMilliseconds: true, includeOffset: false }) ?? utcDateTime.replace('Z', '')
}

export const convertTimeZoneDateTimeToUtc = (
  localDateTime: string | undefined,
  timeZone: string | TimeZone | undefined,
): string => {
  if (!localDateTime) {
    return ''
  }

  const zone = typeof timeZone === 'string' ? timeZone : timeZone?.zone
  if (!zone) {
    return localDateTime.includes('Z') ? localDateTime : new Date(localDateTime).toISOString()
  }

  const dt = DateTime.fromISO(localDateTime, { zone }).toUTC()
  return dt.toISO({ suppressMilliseconds: false, includeOffset: false }) + 'Z'
}

export const TIMEZONE_ID_HELSINKI = 366
